import {IImportService} from "./IImportService";
import {BaseService} from "./BaseService";
import {Employee} from '../entities/Employee'
import { StateService } from "@uirouter/angularjs";
import { ImportField } from "../models/import/ImportField";
import { ImportError } from "../models/import/ImportError";
import { ServerImportField } from "../models/serverimport/ServerImportField";
import { ImportColumn } from "../models/import/ImportColumn";

export class EmployeeService extends BaseService<Employee> {
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, Employee);
    }
    protected getBaseUrl():string{
        return "employee";
    }
    getByEmail(email:string):ng.IPromise<Employee>{
        // Modified 022519 by BA to put name as a query parameter to handle special characters (# and %)
        return this.useBaseGetHandler(this.getBaseUrl(),"email?email="+ encodeURIComponent(email), {});
    }
    getByRfid(rfidTag:string):ng.IPromise<Employee>{
        return this.useBaseGetHandler(this.getBaseUrl(),"rfidtag/"+rfidTag, {});
    }
    
    getReport(numberOfDays:number){
        var config:any = {
            headers: {
                'Content-type': 'application/json',
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'arraybuffer'
        };
        var timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.useGetHandler("Report", "EmployeeWorkHours?timeZoneId=" + timeZoneId+"&numberOfDays=" + numberOfDays, config);
    }
    import(entities:Employee[],test:boolean):ng.IPromise<any>{
        return this.usePostHandler(this.getBasesUrl(),"import?test="+test, entities);
    }
}
